import type { FunctionComponent } from 'react';
import { Text } from '@kanda-libs/ks-design-library';

import type { FAQItem } from './types';
import Card from './Card';
import useFAQs from './useFAQs';

export interface FAQProps {
  items?: FAQItem[];
}

const FAQs: FunctionComponent<FAQProps> = function ({ items }) {
  const { isActive, onClick } = useFAQs();

  if (!items) return null;

  return (
    <div className="flex flex-col mt-12 md:mt-20">
      <div className="flex flex-row mx-auto mb-6 md:mb-10">
        <Text
          text="Frequently asked"
          className="mr-2 text-20-24-em md:text-32-40-em"
        />
        <Text
          text="questions"
          className="mr-2 text-green-400 text-20-24-em md:text-32-40-em"
        />
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-5 md:px-16">
        {items.map((item: FAQItem, index) => (
          <Card
            item={item}
            key={item.title}
            isActive={isActive === index}
            onClick={() => onClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQs;
